import {CutAndEdgeOrderMFCGroup, CutAndEdgeOrderSheetMaterialGroup} from '../../types';

export const isSheetMaterialGroup = (group : (CutAndEdgeOrderMFCGroup | CutAndEdgeOrderSheetMaterialGroup)) : group is CutAndEdgeOrderSheetMaterialGroup => {

    if(group.type === 'SHEET_MATERIAL') return true;
    return false;
    
}